import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Creditcard = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M3 10v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M3 10V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3M3 10h18M7 14h3'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.75 4.003A2.75 2.75 0 0 0 2 6.753V9h19.996v1.5H2v6.746a2.75 2.75 0 0 0 2.75 2.75h14.496a2.75 2.75 0 0 0 2.75-2.75v-10.5a2.747 2.747 0 0 0-2.748-2.743zm2 8.497a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
